// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"6fda297e","253":"855174b8","289":"8e0feb76","453":"3e4fc934","493":"e4f59789","795":"5cc2d497","810":"5232320f","869":"22129474","942":"251ba59c"}[chunkId] + ".chunk.js";
};